const de = {
  time_zone: 'Zeitzone',
  chart: 'Diagramm',

  //Timeframes every
  every: 'Jede',
  granularity: 'Granularität',
  second: 'Sekunde',
  seconds: 'Sekunden',
  seconds_short: 's',
  minute: 'Minute',
  minutes: 'Minuten',
  minute_short: 'm',
  hour: 'Stunde',
  hours: 'Stunden',
  hour_short: 'h',
  day: 'Tag',
  days: 'Tage',
  no_auto_refresh_short: 'Keine',

  // chrono units
  nanos: 'Nanos',
  micros: 'Mikros',
  millis: 'Millis',
  half_days: 'Halbe Tage',
  weeks: 'Wochen',
  months: 'Monate',
  years: 'Jahre',
  decades: 'Jahrzehnte',
  centuries: 'Jahrhunderte',
  millennia: 'Jahrtausende',
  eras: 'Epochen',
  forever: 'Für immer',

  //status
  on: 'Ein',
  off: 'Aus',
  auto: 'Automatisch',

  //common
  sensor_index: 'Sensorindex',
  slave_device_number: 'Slave-Gerätenummer',
  select: 'Auswählen',
  create: 'Erstellen',
  update: 'Aktualisieren',
  relay_index: 'Relaisindex',
  devices: 'Geräte',
  device_name: 'Gerätename',
  device_number: 'Gerätenummer',

  //command status
  pending: 'Ausstehend',
  sent: 'Gesendet',
  cancelled: 'Abgebrochen',
  status_ok: 'Ok',
  status_nok: 'Nicht Ok',
  timeout: 'Zeitüberschreitung',
  unknown: 'Unbekannt',

  //Text
  text_add: 'Hinzufügen',
  text_edit: 'Bearbeiten',
  no_data_for_selected_period: 'Es gibt keine Daten für den angegebenen Zeitraum',
  choose_location: 'Wählen Sie einen Ort',
  more_information: 'Weitere Informationen',
  track_device: 'Gerät verfolgen',
  not_found: 'Nicht gefunden',
  powered_by: 'Unterstützt von ',

  // Solution types
  solution_none: 'Nicht zugewiesen',
  solution_agri: 'Agrarisch',
  solution_air_quality: 'Saubere Luft',
  solution_street_lights: 'Straßenbeleuchtung',
  solution_pump_station: 'Pumpstation',
  solution_smart_waste: 'Smart Waste',
  solution_level: 'Pegelüberwachung',
  solution_gas: 'Gasüberwachung',
  solution_pressure: 'Drucküberwachung',
  solution_smart_water: 'Smart Water',
  solution_energy: 'Energieüberwachung',
  solution_environment_monitoring: 'Umweltüberwachung',

  //Control buttons
  add_button: 'Hinzufügen',
  edit_button: 'Bearbeiten',
  save_button: 'Speichern',
  cancel_button: 'Abbrechen',
  language_button: 'Sprache',
  logout_button: 'Abmelden',
  change_info_for_field: 'Feldinformationen ändern',
  on_button: 'Ein',
  off_button: 'Aus',
  auto_button: 'Auto',
  toggle_button: 'Umschalten',
  door_open_sensor_text: 'Geöffnet',
  door_closed_sensor_text: 'Geschlossen',
  no_auto_refresh: 'Keine automatische Aktualisierung',
  refresh_now: 'Jetzt aktualisieren',

  //Drawer form fields
  drawer_field_information_text: 'Feldinformationen',
  drawer_devices_config: 'Gerätekonfiguration',
  drawer_layer_name: 'Ebenenname',
  drawer_status: 'Status',
  drawer_region_name: 'Regionsname',
  drawer_description: 'Beschreibung',
  drawer_layer_size: 'Ebenengröße',
  drawer_previous_culture: 'Vorherige Kultur',
  drawer_device: 'Gerät',
  drawer_sensor: 'Sensor',

  //Menu
  menu_home: 'Startseite',
  menu_calendar: 'Kalender',
  menu_journal: 'Journal',
  menu_alarms: 'Alarme',
  menu_old_home: 'Startseite (alt)',
  menu_streetlight: 'Straßenlaterne',
  menu_trashbags: 'Abfallsäcke',
  menu_collections: 'Sammlungen',
  menu_truck_collections: 'LKW-Sammlungen',
  menu_truck_collections_by_container: 'LKW-Sammlungen nach Container',
  menu_container_collections: 'Container-Sammlungen',
  menu_reports: 'Berichte',

  //Map banner text
  map_banner_select: 'Wählen Sie ein Feld aus',
  map_banner_create: 'Ein Feld erstellen',
  map_cluster_devices_header: 'Geräte ({{deviceCount}})',

  //Field information widget
  field_info_view: 'Ansicht',
  field_info_alarms: 'Alarme',
  field_info_header: 'Feldinformationen',
  field_info_status: 'STATUS',
  field_info_region: 'REGION',
  field_info_description: 'BESCHREIBUNG',
  field_info_area: 'FLÄCHE',
  field_info_previous_culture: 'VORHERIGE KULTUR',
  field_info_linked_devices: 'Verknüpfte Geräte',
  field_info_distance_traveled: 'Zurückgelegte Entfernung',

  //Forecast widget
  forecast_today: 'Heute',
  forecast_three_days: '3 Tage',
  forecast_five_days: '5 Tage',
  forecast_seven_days: '7 Tage',
  forecast_min_temp: 'MIN TEMP',
  forecast_max_temp: 'MAX TEMP',
  forecast_cloud_cover: 'BEDECKUNG',
  forecast_rain: 'REGEN',
  forecast_wind: 'WIND',
  forecast_wind_direction: 'WINDRICHTUNG',
  forecast_humidity: 'LUFTFEUCHTIGKEIT',

  //Rain Widget
  rain_widget_header: 'Regen',

  //Humidity Widget
  humidity_widget_text: 'Luftfeuchtigkeit',

  //Soil Moisture Widget
  soil_moisture_widget_text: 'Bodenfeuchte',

  //Control Widget
  control_widget_header: 'Steuerung',
  relay_control_get_relay_statuses: 'Relaisstatus abrufen',
  poll_linked_devices: 'Verknüpfte Geräte abfragen',

  //Sensor information widget
  sensor_reference_values_label: 'Referenzwerte',
  sensor_board_label: 'SCHALTTAFEL',
  sensor_all_info_header: 'Sensoren',
  sensor_info_header: 'Sensorinformationen',
  sensor_info_name: 'NAME',
  sensor_info_device: 'GERÄT',
  sensor_info_type: 'TYP',
  sensor_info_status: 'STATUS',
  sensor_info_max: 'MAX',
  sensor_info_min: 'MIN',
  sensor_info_avg: 'DURCHSCHNITT',
  sensor_info_current: 'AKTUELL',
  sensor_info_counters: 'ZÄHLER',
  sensor_info_start_button: 'START',
  sensor_info_stop_button: 'STOPP',
  sensor_last_refresh: 'Aktualisiert: {{time}}',
  sensor_info_board: 'SCHALTTAFEL',
  sensor_info_manufacturer: 'HERSTELLER',
  sensor_info_model: 'MODELL',
  sensor_info_serial_number: 'SERIENNUMMER',
  sensor_info_diameter: 'DURCHMESSER',

  //Street lights information widget
  power_usage: 'STROMVERBRAUCH',
  lighting: 'BELEUCHTUNG',
  lights_on: 'An',
  lights_off: 'Aus',
  door_open: 'Geöffnet',
  door_closed: 'Geschlossen',

  //Pump station information
  pump1: 'Pumpe 1',
  pump2: 'Pumpe 2',

  //Device Information
  device_information_name: 'Name',
  device_information_number: 'Nummer',
  device_information_model: 'Modell',
  device_information_latitude: 'Breitengrad',
  device_information_longitude: 'Laengengrad',

  //Widget detailed button
  widget_detailed_button: 'Details',

  //Back To Map Button
  back_to_map_btn: 'Zurück zur Karte',

  //Wind widget
  wind_widget_header: 'Wind',

  //Dashboard
  boiler_condition_information: 'Informationen zum Betriebszustand des Kessels',
  street_light_information: 'Informationen zur Straßenbeleuchtung',
  pump_station_information: 'Informationen zur Pumpstation',
  default_information_panel: 'Geräteinformationen',
  dashboard_header: 'Dashboard für Feld:',
  dashboard_chart_value: 'Wert',
  select_sensor_message: 'Wählen Sie einen Sensor',

  //OnOffAutoLoader
  await_command_execution: 'Bitte warten Sie auf die Ausführung des Befehls',
  command_successful: 'Befehl erfolgreich ausgeführt',
  command_unsuccessful: 'Fehler beim Ausführen des Befehls',
  command_error: 'Befehl nicht ausgeführt',
  loading: 'Laden',

  //Alarms
  alarms_page_header: 'Alarme',
  alarms_page_device_header: 'Alarme für Gerät {{deviceNumber}}',

  alarms_table_date_header: 'Datum',
  alarms_table_device_number_header: 'Gerätenummer',
  alarms_table_type_header: 'Typ',
  alarms_table_description_header: 'Beschreibung',
  alarms_table_sensor_name: 'Sensorname',

  alarms_none_message: 'Keine Alarme für den ausgewählten Zeitraum',
  alarms_control_panel_select_date_message: 'Datum auswählen',
  alarms_control_panel_from_date: 'Ab Datum',
  alarms_control_panel_to_date: 'Bis Datum',
  alarms_control_panel_alarm_type: 'Alarmtyp',
  alarms_control_panel_alarm_status: 'Alarmstatus',
  alarms_control_panel_by_device_number: 'Suche nach Gerätenummer',
  alarms_control_panel_header: 'Alarmfilter',

  // Value ranges
  value_ranges_light_rain: 'Leichter Regen',
  value_ranges_moderate_rain: 'Mäßiger Regen',
  value_ranges_heavy_rain: 'Starker Regen',
  value_ranges_violent_rain: 'Heftiger Regen',
  value_ranges_calm_wind: 'Windstille',
  value_ranges_light_air: 'Leichte Brise',
  value_ranges_light_breeze: 'Leichte Brise',
  value_ranges_gentle_breeze: 'Sanfte Brise',
  value_ranges_moderate_breeze: 'Mäßige Brise',
  value_ranges_fresh_breeze: 'Frische Brise',
  value_ranges_strong_breeze: 'Starker Wind',
  value_ranges_high_wind: 'Starker Wind',
  value_ranges_gale: 'Sturm',
  value_ranges_severe_gale: 'Schwerer Sturm',
  value_ranges_storm: 'Sturm',
  value_ranges_violent_storm: 'Heftiger Sturm',
  value_ranges_hurricane: 'Hurrikan',
  value_ranges_north_1: 'Nord',
  value_ranges_north_notheast: 'Nord-Nordost',
  value_ranges_notheast: 'Nordost',
  value_ranges_east_notheast: 'Ost-Nordost',
  value_ranges_east: 'Ost',
  value_ranges_east_southeast: 'Ost-Südost',
  value_ranges_southeast: 'Südost',
  value_ranges_south_south_east: 'Süd-Südost',
  value_ranges_south: 'Süd',
  value_ranges_south_southwest: 'Süd-Südwest',
  value_ranges_southwest: 'Südwest',
  value_ranges_west_southwest: 'West-Südwest',
  value_ranges_west: 'Westen',
  value_ranges_west_northwest: 'West-Nordwest',
  value_ranges_northwest: 'Nordwesten',
  value_ranges_north_northwest: 'Nord-Nordwest',
  value_ranges_north_2: 'Norden',
  value_ranges_dry: 'Trocken',
  value_ranges_normal: 'Normal',
  value_ranges_wet: 'Feucht',
  value_ranges_frost_point: 'Frostpunkt',
  value_ranges_frost_point_danger: 'Gefährlicher Frostpunkt',
  value_ranges_dew_point: 'Taupunkt',

  // Data Table Widget
  data_table_widget_header: 'Daten',
  data_table_measurements: 'Messwerte',
  data_table_alarms: 'Alarme',
  data_table_widget_from_date: 'Von Datum',
  data_table_widget_to_date: 'Bis Datum',
  data_table_date: 'Datum',
  data_table_value: 'Wert',
  data_table_range: 'Bereich',
  flow: 'Durchfluss',
  raw_readings: 'Rohdaten',
  y_axis_include_zero: '0 auf Y-Achse anzeigen',
  chart_options: 'Diagrammoptionen',

  //sensors types
  rain_sensor: 'Regensensor',
  level_sensor: 'Pegelsensor',
  wind_speed_sensor: 'Windgeschwindigkeitssensor',
  wind_direction_sensor: 'Windrichtungssensor',
  water_meter: 'Wasserzähler Sensor',
  pressure_sensor: 'Drucksensor',
  humidity_sensor: 'Luftfeuchtigkeitssensor',
  temperature_sensor: 'Temperatursensor',
  gas_flow_meter: 'Gasdurchflussmesser',
  heat_meter: 'Wärmemesser',
  barometric_pressure_sensor: 'Barometrischer Drucksensor',
  soil_moisture_sensor: 'Bodenfeuchtesensor',
  on_off_sensor: 'Relais-Schalter',
  generic_analog_sensor: '--',
  power_meter: 'Stromzähler',
  soil_temperature_sensor: 'Bodentemperatur',
  dew_point_sensor: 'Taupunktsensor',
  particulate_matter_sensor: 'Feinstaubsensor',
  geiger_mueller_counter: 'Strahlungszähler',
  soil_potential_sensor: 'Bodenpotenzial-Sensor',
  weight_sensor: 'Gewichtssensor',

  sensor: {
    rain: {
      name: 'Regensensor',
      valueRanges: {
        no_rain: {
          abbrv: 'Kein Regen',
          description: 'Wenn die Niederschlagsrate < 0,1 mm pro Stunde ist',
        },
        light_rain: {
          abbrv: 'Leichter Regen',
          description: 'Wenn die Niederschlagsrate zwischen 0,1 und 2,5 mm pro Stunde liegt',
        },
        moderate_rain: {
          abbrv: 'Mäßiger Regen',
          description: 'Wenn die Niederschlagsrate zwischen 2,5 und 7,6 mm pro Stunde liegt',
        },
        heavy_rain: {
          abbrv: 'Starker Regen',
          description: 'Wenn die Niederschlagsrate zwischen 7,6 und 50 mm pro Stunde liegt',
        },
        violent_rain: {
          abbrv: 'Heftiger Regen',
          description: 'Wenn die Niederschlagsrate > 50 mm pro Stunde beträgt',
        },
      },
    },
    windDirection: {
      name: 'Windrichtungssensor',
      valueRanges: {
        north_1: {
          abbrv: 'N',
          description: 'Norden (349° - 011°)',
        },
        north_2: {
          abbrv: 'N',
          description: 'Norden (349° - 011°)',
        },
        north_northeast: {
          abbrv: 'NNO',
          description: 'Nordnordost (012°-033°)',
        },
        northeast: {
          abbrv: 'NO',
          description: 'Nordost (034°-056°)',
        },
        east_northeast: {
          abbrv: 'ONO',
          description: 'Ostnordost (102°-123°)',
        },
        east: {
          abbrv: 'O',
          description: 'Ost (079°-101°)',
        },
        east_southeast: {
          abbrv: 'OSO',
          description: 'Ostsüdost (102°-123°)',
        },
        southeast: {
          abbrv: 'SO',
          description: 'Südost (124°-146°)',
        },
        south_southeast: {
          abbrv: 'SSO',
          description: 'Südsüdost (147°-168°)',
        },
        south_southwest: {
          abbrv: 'SSW',
          description: 'Südsüdwest (192°-213°)',
        },
        south: {
          abbrv: 'S',
          description: 'Süd (169°-191°)',
        },
        southwest: {
          abbrv: 'SW',
          description: 'Südwest (214°-236°)',
        },
        west_southwest: {
          abbrv: 'WSW',
          description: 'West-Südwest (237°-258°)',
        },
        west: {
          abbrv: 'W',
          description: 'West (259°-281°)',
        },
        west_northwest: {
          abbrv: 'WNW',
          description: 'Westnordwest (282°-303°)',
        },
        northwest: {
          abbrv: 'NW',
          description: 'Nordwest (304°-326°)',
        },
        north_northwest: {
          abbrv: 'NNW',
          description: 'Nordnordwest (327°-348°)',
        },
      },
    },
    windSpeed: {
      name: 'Windgeschwindigkeitssensor',
      valueRanges: {
        no_wind: {
          abbrv: 'Kein Wind',
          description: '(0 m/s - 0,1 m/s)',
        },
        calm_wind: {
          abbrv: 'Windstill',
          description: '(0,1 m/s - 1 m/s)',
        },
        light_air: {
          abbrv: 'Leichte Brise',
          description: '(2 m/s - 3 m/s)',
        },
        light_breeze: {
          abbrv: 'Leichte Brise',
          description: '(4 m/s - 6 m/s)',
        },
        gentle_breeze: {
          abbrv: 'Sanfte Brise',
          description: '(7 m/s - 10 m/s)',
        },
        moderate_breeze: {
          abbrv: 'Mäßige Brise',
          description: '(11 m/s - 16 m/s)',
        },
        fresh_breeze: {
          abbrv: 'Frische Brise',
          description: '(17 m/s - 21 m/s)',
        },
        strong_breeze: {
          abbrv: 'Starker Wind',
          description: '(22 m/s - 27 m/s)',
        },
        high_wind: {
          abbrv: 'Starker Wind',
          description: '(28 m/s - 33 m/s)',
        },
        gale: {
          abbrv: 'Sturm',
          description: '(34 m/s - 40 m/s)',
        },
        severe_gale: {
          abbrv: 'Schwerer Sturm',
          description: '(41 m/s - 47 m/s)',
        },
        storm: {
          abbrv: 'Sturm',
          description: '(48 m/s - 55 m/s)',
        },
        violent_storm: {
          abbrv: 'Heftiger Sturm',
          description: '(56 m/s - 63 m/s)',
        },
        hurricane: {
          abbrv: 'Hurrikan',
          description: '(64 m/s - 77 m/s)',
        },
      },
    },
    soil_temperature: {
      valueRanges: {
        idealMin: {
          abbrv: 'Langsames Wachstum',
          description: 'Temperatur liegt unter 18,3°C',
        },
        idealMax: {
          abbrv: 'Ideale Bedingungen',
          description: 'Idealbereich (zwischen 18,4°C und 30°C)',
        },
        warm: {
          abbrv: 'Warm',
          description: 'Langsames Wachstum (zwischen 30,1°C und 32,2°C)',
        },
        hot: {
          abbrv: 'Heiß',
          description: 'Nicht effizientes Wachstum (zwischen 32,3°C und 45°C)',
        },
        dangerous: {
          abbrv: 'Gefährlich',
          description: 'Bakterien sterben ab, Feuchtigkeitsverlust (> 45,1°C)',
        },
      },
    },
    soilmoisture: {
      valueRanges: {
        dry: {
          abbrv: 'Trocken',
          description: 'Gefährlich niedrige Bodenfeuchtigkeit (< 80%)',
        },
        normal: {
          abbrv: 'Bewässern',
          description: 'Bewässerung erforderlich (zwischen 80% und 90%)',
        },
        wet: {
          abbrv: 'Feucht',
          description: 'Keine Bewässerung erforderlich (zwischen 90% und 100%)',
        },
      },
    },
    dew_point_sensor: {
      valueRanges: {
        frost_point: {
          abbrv: 'Frost',
          description: 'Der Taupunkt liegt unter 1°C.',
        },
        frost_point_danger: {
          abbrv: 'Gefahr von Frost',
          description: 'Der Taupunkt liegt unter 5°C.',
        },
        dew_point: {
          abbrv: 'Taupunkt',
          description: 'Der Taupunkt liegt über 5°C.',
        },
      },
    },
    gammaRadiation: {
      valueRanges: {
        normal: {
          abbrv: 'Normal',
        },
        abnormal: {
          abbrv: 'Hoch',
        },
        dangerous: {
          abbrv: 'Gefährlich hoch',
        },
      },
    },
    moisture: {
      valueRanges: {
        dry: {
          abbrv: 'Trocken',
        },
        normal: {
          abbrv: 'Normal',
        },
        wet: {
          abbrv: 'Feucht',
        },
      },
    },
    temperature: {
      valueRanges: {
        cool: {
          abbrv: 'Kühl',
        },
        ideal: {
          abbrv: 'Ideal',
        },
        warm: {
          abbrv: 'Warm',
        },
        hot: {
          abbrv: 'Heiß',
        },
        dangerous: {
          abbrv: 'Gefährlich heiß',
        },
      },
    },
    airMicroGrams: {
      valueRanges: {
        good: {
          abbrv: 'Niedrig',
        },
        moderate: {
          abbrv: 'Mäßig',
        },
        minimal: {
          abbrv: 'Minimal',
        },
        sensitive: {
          abbrv: 'Empfindlich',
        },
        discomfort: {
          abbrv: 'Unangenehm',
        },
        unhealthy: {
          abbrv: 'Ungesund',
        },
        veryUnhealthy: {
          abbrv: 'Sehr ungesund',
        },
        hazardous: {
          abbrv: 'Gefährlich',
        },
        respiratoryIllness: {
          abbrv: 'Gefährlich (Atemwegserkrankungen)',
        },
        healthImpact: {
          abbrv: 'Gefährlich für die Gesundheit',
        },
      },
    },
    barometricPressure: {
      valueRanges: {
        low: {
          abbrv: 'Niedrig',
          description: 'Barometrischer Druck liegt unter 850.',
        },
        normal: {
          abbrv: 'Normal',
          description: 'Barometrischer Druck liegt über 850, aber unter 1500.',
        },
        high: {
          abbrv: 'Hoch',
          description: 'Barometrischer Druck liegt über 1500, aber unter 3000.',
        },
      },
    },
    load_cells: {
      valueRanges: {
        low: {
          abbrv: 'Normal',
          description: 'Last liegt unter 999 kN.',
        },
        normal: {
          abbrv: 'Warnung',
          description: 'Last liegt zwischen 1000 und 1100 kN.',
        },
        high: {
          abbrv: 'Alarm',
          description: 'Last liegt über 1100 kN.',
        },
      },
    },
  },
  // GEOMAN MAP LIBRARY CUSTOM TRANSLATE
  // --tooltips--
  placeMarker: 'Klicken, um Marker zu platzieren',
  firstVertex: 'Klicken, um ersten Eckpunkt zu setzen',
  continueLine: 'Klicken, um das Zeichnen fortzusetzen',
  finishLine: 'Klicken Sie auf einen vorhandenen Marker, um zu beenden',
  finishPoly: 'Klicken Sie auf den ersten Marker, um zu beenden',
  finishRect: 'Klicken, um zu beenden',
  startCircle: 'Klicken, um Kreismittelpunkt zu setzen',
  finishCircle: 'Klicken, um Kreis zu beenden',
  placeCircleMarker: 'Klicken, um Kreismarker zu platzieren',
  placeText: 'Klicken, um Text zu platzieren',

  // -- actions --
  finish: 'Beenden',
  cancel: 'Abbrechen',
  removeLastVertex: 'Letzten Eckpunkt entfernen',

  // -- button titles --
  drawMarkerButton: 'Marker zeichnen',
  drawPolyButton: 'Polygone zeichnen',
  drawLineButton: 'Polylinie zeichnen',
  drawCircleButton: 'Kreis zeichnen',
  drawRectButton: 'Rechteck zeichnen',
  editButton: 'Ebenen bearbeiten',
  dragButton: 'Ebenen ziehen',
  cutButton: 'Ebenen schneiden',
  deleteButton: 'Ebenen entfernen',
  drawCircleMarkerButton: 'Kreismarker zeichnen',
  snappingButton: 'Verschobenen Marker an anderen Ebenen und Eckpunkten ausrichten',
  pinningButton: 'Gemeinsame Eckpunkte zusammenstecken',
  rotateButton: 'Ebenen drehen',
  drawTextButton: 'Text zeichnen',

  // CONFIRMATION DIALOG WINDOW
  confirmMessage: 'Sind Sie sicher, dass Sie dies (Polygon oder Bereich) löschen möchten?',
  confirmAgreeButton: 'Zustimmen',
  confirmDisagreeButton: 'Ablehnen',

  // Journal
  journal_page_header: 'Journal',

  // Calendar"
  calendar_page_header: 'Kalender',

  // Period-Selector options
  period_label: 'Zeitraum',
  route_date_selector: 'Routendatum',

  period_date_range_option: 'Datumsbereich',
  period_custom_option: 'Benutzerdefiniert',
  period_today_option: 'Heute',
  period_week_option: 'Woche',
  period_month_option: 'Monat',
  period_last_h_option: 'Letzte Stunde',
  period_last_2_h_option: 'Letzte 2 Stunden',
  period_last_4_h_option: 'Letzte 4 Stunden',
  period_last_24_h_option: 'Letzte 24 Stunden',
  period_last_48_h_option: 'Letzte 48 Stunden',

  // YAMBOL HEADER
  municipality_yambol: 'Gemeinde Yambol',

  // Devices List
  search_placeholder: 'Gerätename suchen',

  // Error-handling
  toast_server_error_message: 'Bei einer Ihrer Anfragen an den Server ist ein Fehler aufgetreten',
  toast_alarms_error_message: 'Fehler beim Abrufen der Alarme',
  toast_map_error_message: 'Fehler beim Abrufen der Karte',
  toast_dashboard_error_message: 'Fehler beim Abrufen des Dashboards',
  toast_devices_error_message: 'Fehler beim Abrufen der Geräte',
  toast_device_config_error_message:
    'Fehler beim Abrufen der Gerätekonfiguration für: {{deviceNumber}}',
  toast_device_current_values_error_message:
    'Fehler beim Abrufen der aktuellen Werte für: {{deviceNumber}}',
  toast_devices_location_error_message: 'Fehler beim Abrufen des Gerätestandorts',
  toast_map_setting_per_name_error_message:
    'Fehler beim Abrufen der Karten-Einstellungen Ihrer aktuellen Karte',
  toast_map_settings_error_message: 'Fehler beim Abrufen aller Karten-Einstellungen',
  toast_get_user_error_message: 'Fehler beim Abrufen Ihres Benutzers',
  toast_set_user_language_error_message: 'Fehler beim Einstellen der Sprache',

  // CurrentValuesBox
  current_values_box_info_description: 'Keine Informationen',
  current_values_box_reference_values: 'Referenzwerte',
  device_info_panel_loading_values: 'Aktuelle Werte werden geladen',
  device_info_panel_no_values: 'Keine aktuellen Werte verfügbar',
  device_info_panel_values_error: 'Aktuelle Werte konnten nicht geladen werden',

  // Buttons and dropdowns
  alarms_export_header: 'Alarme',
  alarms_export_header_with_device: `Alarme: {{device_number}}`,
  alarms_export_search: 'Suche',
  alarms_export_download: 'Herunterladen',
  alarms_export_format: 'Format',

  // Table columns
  alarms_export_table_date: 'Datum',
  alarms_export_table_device_number: 'Gerätenummer',
  alarms_export_table_device_name: 'Gerätename',
  alarms_export_table_severity: 'Schweregrad',
  alarm_severity_tooltip: 'Schweregrad: {{value}} von 10',
  alarm_severity_none_tooltip: 'Kein Schweregrad für diesen Alarm gemeldet',
  alarms_export_table_sensor_index: 'Sensorindex',
  alarms_export_table_sensor_name: 'Sensorname',
  alarms_export_table_alarm_type: 'Typ',
  alarm_type_on_off_alarm: 'Ein/Aus-Alarm',
  alarm_type_no_zero_consumption: 'Kein Nullverbrauch',
  alarm_type_all_zero_consumption: 'Nullverbrauch',
  alarm_type_low_flow: 'Niedriger Durchfluss',
  alarm_type_high_flow: 'Hoher Durchfluss',
  alarm_type_high_consumption: 'Hoher Verbrauch',
  alarm_type_missed_transmission: 'Fehlende Übertragung',
  alarm_type_device_removed: 'Gerät entfernt',
  alarm_type_low_level: 'Niedriger Füllstand',
  alarm_type_high_level: 'Hoher Füllstand',
  alarm_type_tamper: 'Manipulation',
  alarm_type_oversized: 'Überdimensioniert',
  alarm_type_undersized: 'Unterdimensioniert',
  alarm_type_low_battery: 'Batterie schwach',
  alarm_type_blockage: 'Verstopfung',
  alarm_type_burst: 'Rohrbruch',
  alarm_type_reverse_flow: 'Rückfluss',
  alarm_type_range_event: 'Bereichsereignis',
  alarm_type_very_low_level: 'Sehr niedriger Füllstand',
  alarm_type_very_high_level: 'Sehr hoher Füllstand',
  alarm_type_leakage: 'Leckage',
  alarm_type_low_temperature: 'Niedrige Temperatur',
  alarm_type_no_consumption: 'Kein Verbrauch',
  alarm_type_negative_flow: 'Negativer Durchfluss',
  alarm_type_empty_spool: 'Leeres Rohr',
  alarm_type_combination_of_alarms: 'Alarmkombination',
  alarm_type_standstill: 'Stillstand',
  alarm_type_reset_error: 'Reset-Fehler',
  alarm_type_rf_error: 'RF-Fehler',
  alarm_type_cs_error: 'CS-Fehler',
  alarm_type_measuring_error: 'Messfehler',
  alarm_type_reset_event: 'Reset-Ereignis',
  alarm_type_magnetic_field: 'Magnetfeld',
  alarm_type_sensor_fraud: 'Sensormanipulation',
  alarms_export_table_alarm_status: 'Status',
  alarms_export_table_description: 'Beschreibung',
  alarms_export_chip_status_active: 'Aktiv',
  alarms_export_chip_status_inactive: 'Inaktiv',
  alarms_export_switch_title_label: 'Auto-Aktualisierung',
  alarms_export_error_alert_message: 'Beim Generieren der Daten ist ein Fehler aufgetreten.',
  alarms_export_error_too_big_query:
    'Das Abrufen der Historie vom Super Admin für alle Geräte ist eine zu große Anfrage. Bitte wählen Sie ein Unternehmen.',

  /*
   * |=================|
   * | Task Scheduler  |
   * |=================|
   */

  task_scheduler_link_label: 'Planer',
  task_scheduler_title: 'Aufgabenplaner',
  task_scheduler_remove: 'Entfernen',
  task_scheduler_remove_confirmation: 'Sind Sie sicher, dass Sie die Aufgabe löschen möchten?',
  task_scheduler_confirm: 'Bestätigen',
  task_scheduler_cancel: 'Abbrechen',
  task_scheduler_remove_active: 'Aktive Aufgabe kann nicht entfernt werden',
  task_scheduler_action_not_reversible: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  task_scheduler_edit: 'Bearbeiten',

  // Form
  task_scheduler_form_name: 'Aufgabenname',
  task_scheduler_form_from_date: 'Von Datum',
  task_scheduler_form_to_date: 'Bis Datum',
  task_scheduler_form_repeat: 'Wiederholen',
  task_scheduler_form_period: 'Zeitraum',
  task_scheduler_form_temporal: 'Zeitlich',
  task_scheduler_form_execution_hour: 'Ausführungsstunde',
  task_scheduler_form_execution_minute: 'Ausführungsminute',

  // Toast messages
  task_scheduler_form_create_message: 'Ereignis erfolgreich hinzugefügt',
  task_scheduler_form_update_message: 'Ereignis erfolgreich aktualisiert',
  task_scheduler_form_create_error_message: 'Fehler beim Erstellen des Ereignisses',
  task_scheduler_form_update_error_message: 'Fehler beim Aktualisieren der Aufgabe',
  task_scheduler_form_delete_message: 'Ereignis erfolgreich entfernt',

  // Task execution
  task_execution_error_loading_message: 'Fehler beim Laden geplanter Ereignisse',

  // Tasks list
  scheduled_tasks_list_event_name: 'Ereignisname',
  scheduled_tasks_list_start_date: 'Startdatum',
  scheduled_tasks_list_end_date: 'Enddatum',
  scheduled_tasks_list_execution_time: 'Ausführungszeit',
  scheduled_tasks_list_last_execution: 'Letzte Ausführung',
  scheduled_tasks_list_is_active: 'Ist aktiv',
  scheduled_tasks_event_logs_btn_text: 'Ereignisprotokolle',
  scheduled_tasks_view_btn_text: 'Ansehen',

  // History table
  scheduled_event_history_title: 'Aufgabenverlauf',
  scheduled_tasks_history_date_of_execution_header: 'Ausführungsdatum',
  scheduled_tasks_history_status_header: 'Ausführungsstatus',
  scheduled_tasks_history_overview_btn_text: 'Übersicht',
  scheduled_tasks_history_task_status_done: 'Erledigt',
  scheduled_tasks_history_task_status_pending: 'Ausstehend',
  scheduled_tasks_history_task_status_failed: 'Fehlgeschlagen',
  scheduled_tasks_history_task_status_done_with_errors: 'Erledigt mit Fehlern',

  // Task Overview
  task_scheduler_command_task_overview: 'Aufgabenübersicht',
  task_overview_scheduled_event_name: 'Name des geplanten Ereignisses',
  task_overview_desired_state: 'Gewünschter Zustand',
  task_overview_command_state: 'Befehlstatus',

  //Task view (Event form)
  scheduled_task_event_form_required_state: 'Erforderlicher Zustand',
  scheduled_task_event_form_required_states: 'Erforderliche Zustände',
  scheduled_task_event_form_scheduled_event: 'Geplantes Ereignis',
  scheduled_task_event_form_new_scheduled_event: 'Neues geplantes Ereignis',
  scheduled_task_event_form_edit_scheduled_event: 'Geplantes Ereignis bearbeiten',
  scheduled_task_event_form_event_type: 'Ereignistyp',
  scheduled_task_event_form_start_date: 'Startdatum',
  scheduled_task_event_form_end_date: 'Enddatum',
  scheduled_task_event_form_last_execution: 'Letzte Ausführung',
  scheduled_task_event_form_execution_time: 'Ausführungszeit',
  scheduled_task_event_form_relay_state: 'Relaiszustand',
  scheduled_task_event_form_select: 'Auswählen',
  scheduled_task_event_form_hour: 'Ausführungsstunde des Geräts',
  scheduled_task_event_form_minute: 'Ausführungsminute des Geräts',
  scheduled_task_event_form_modbus_command_type: 'Befehlstyp',
  scheduled_task_event_form_modbus_command_type_read_coil_1: 'Relaisstatus abrufen',
  scheduled_task_event_form_modbus_command_type_read_register_3: 'Wert abfragen',
  scheduled_task_event_form_modbus_command_type_write_coil_5: 'Befehl senden',

  // Scheduled task event types
  command_type_single_relay_switch: 'Einzelrelais-Schalter',
  command_type_relay_switch: 'Relais-Schalter',
  command_type_auto_relay_switch: 'Automatischer Relais-Schalter',
  command_type_send_date_over_mqtt: 'Datum über MQTT senden',
  command_type_modbus: 'Modbus',
  command_type_tasmota_power: 'Tasmota Power',
  command_type_scheduled_relay_command: 'Geplantes Relais',
  command_type_scheduled_relay_command_4: 'Geplante Relais-Befehle (4)',
  command: 'Befehl',

  // Error handling
  scheduled_tasks_could_not_find_event_with_id:
    'Ereignis mit ID {{event_id}} konnte nicht gefunden werden',
  scheduled_tasks_could_not_get_event_logs_for_event:
    'Protokolle für das Ereignis konnten nicht abgerufen werden',
  scheduled_tasks_could_not_update_event_with_id:
    'Ereignis mit ID {{event_id}} konnte nicht aktualisiert werden',
  logo_error_message: 'Firmenlogo konnte nicht geladen werden',

  //resolvers
  scheduled_tasks_event_name_min_length: 'Der Ereignisname muss mindestens 3 Zeichen lang sein',
  scheduled_tasks_event_name_max_length: 'Der Ereignisname muss kürzer als 50 Zeichen sein',
  scheduled_tasks_from_date_invalid: 'Das Startdatum muss nach heute liegen',
  scheduled_tasks_to_date_invalid: 'Das Enddatum muss nach dem Startdatum liegen',
  scheduled_tasks_execution_hour_range: 'Die Ausführungsstunde muss zwischen 0 und 23 liegen',
  scheduled_tasks_execution_minute_range: 'Die Ausführungsminute muss zwischen 0 und 59 liegen',
  scheduled_tasks_period_required: 'Der Zeitraum muss eine positive ganze Zahl sein',
  scheduled_tasks_temporal_required: 'Ein temporärer Wert ist erforderlich',
  scheduled_tasks_event_device_numbers_length: 'Jede Gerätenummer muss genau 8 Zeichen lang sein',
  scheduled_tasks_event_sensor_index_range:
    'Der Sensorindex muss eine positive ganze Zahl oder 0 sein',
  scheduled_tasks_event_relay_states_required:
    'Für den Typ RELAY_SWITCH müssen Schaltzustände angegeben werden',
  scheduled_tasks_event_required_state_auto_relay:
    'Für den Typ AUTO_RELAY_SWITCH muss ein erforderlicher Zustand angegeben werden',
  scheduled_tasks_event_required_state_tasmota_power:
    'Für den Typ TASMOTA_POWER muss ein erforderlicher Zustand angegeben werden',
  scheduled_tasks_event_slave_device_number_length:
    'Die Slave-Gerätenummer muss genau 8 Zeichen lang sein',
  scheduled_tasks_event_type_invalid: 'Es wurde ein ungültiger Ereignistyp ausgewählt',
  scheduled_tasks_device_number_is_required:
    'Wählen Sie Gerät(e) aus, um ein Ereignis zu erstellen',

  /*
   * |=====================|
   * | License Error Page  |
   * |=====================|
   */
  license_error_page_access_restricted: 'Zugriff eingeschränkt',
  license_warning_access_hold: 'Kontozugriff ausgesetzt',
  license_warning_access_hold_description:
    'Ihr Zugriff auf die Plattform wurde vorübergehend aufgrund einer ungeklärten Zahlung ausgesetzt. Wir empfehlen Ihnen, sich an unseren Support zu wenden oder sich mit Ihrem zuständigen Vertreter in Verbindung zu setzen, um Ihnen bei der Lösung dieses Problems zu helfen.',
  license_warning_no_valid_license: 'Keine gültige Lizenz',
  license_warning_no_valid_license_description:
    'Wir konnten keine gültige Lizenz finden, die mit diesem Konto verknüpft ist. Bitte wenden Sie sich an Ihren zuständigen Vertreter oder kontaktieren Sie unseren Support um Hilfe.',
  license_warning_devices_count_limit_reached: 'Maximale Anzahl von Geräten erreicht',
  license_warning_devices_count_limit_reached_description:
    'Sie haben die maximale Anzahl von Geräten erreicht, die Sie gemäß der Lizenz mit dem Konto verknüpfen können. Wenn Sie mehr hinzufügen möchten, kontaktieren Sie bitte Ihren zuständigen Vertreter oder unseren Support für Unterstützung.',
  license_warning_generic_title: 'Keine Lizenz',
  license_warning_generic_description:
    'Kann aufgrund eines Lizenzproblems nicht fortgesetzt werden.',
  error_forbidden_operation_not_allowed: 'Nicht erlaubt',

  /*
   * |=================|
   * | Trashbags       |
   * |=================|
   */
  trashbags_page_header: 'Abfallsäcke',
  trashbags_status_new: 'Neu',
  trashbags_status_in_progress: 'In Bearbeitung',
  trashbags_status_closed: 'Geschlossen',
  trashbags_fetch_error: 'Fehler beim Abrufen der Chargen',
  trashbags_batch_details_error: 'Fehler beim Abrufen der Chargendetails',
  trashbags_batch_number: 'Sackrolle',
  trashbags_batch_id: 'Rollen-ID',
  trashbags_total_count: 'Gesamt',
  trashbags_new: 'Neu',
  trashbags_in_progress: 'In Bearbeitung',
  trashbags_closed: 'Geschlossen',
  trashbags_id: 'ID',
  trashbags_rfid: 'RFID',
  trashbags_status: 'Status',
  trashbags_account_number: 'Chargennummer',
  trashbags_created_date: 'Erstellungsdatum',
  trashbags_collection_date: 'Abholdatum',
  trashbags_more_info_tooltip: 'Klicken Sie, um weitere Informationen zu sehen',
  trashbags_details_title: 'Sackdetails',
  trashbags_type: 'Typ',
  trashbags_location: 'Standort',
  trashbags_open_in_maps: 'In Google Maps öffnen',
  trashbags_empty_title: 'Keine Sackrollen gefunden',
  trashbags_empty_description: 'Es gibt noch keine Sackrollen zum Anzeigen.',
  trashbags_batch_empty_title: 'Keine Saecke in dieser Rolle',
  trashbags_batch_empty_description: 'Diese Rolle enthaelt noch keine Saecke.',

  /*
   * |=================|
   * | Collections     |
   * |=================|
   */
  collections_page_header: 'Müllabfuhr-Bericht',
  collections_fetch_error: 'Fehler beim Abrufen der Sammeldaten',
  collections_from_date: 'Von Datum',
  collections_to_date: 'Bis Datum',
  collections_account_number: 'Chargennummer',
  collections_account_id: 'Konto-ID',
  collections_count: 'Anzahl der Sammlungen',
  collections_volume: 'Sammlungsvolumen',
  collections_export_csv: 'Exportieren',
  collections_no_data_to_export: 'Keine Daten zum Exportieren',

  /*
   * |====================|
   * | Truck Collections  |
   * |====================|
   */
  truck_collections_page_header: 'LKW-Sammlungen Bericht',
  truck_collections_fetch_error: 'Fehler beim Abrufen der LKW-Sammeldaten',
  truck_collections_from_date: 'Von Datum',
  truck_collections_to_date: 'Bis Datum',
  truck_collections_truck_name: 'LKW-Name',
  truck_collections_count: 'Anzahl der Sammlungen',
  truck_collections_volume: 'Sammlungsvolumen',
  truck_collections_export_csv: 'CSV exportieren',
  truck_collections_view_on_map: 'Auf Karte anzeigen',
  truck_collections_no_data_to_export: 'Keine Daten zum Exportieren',

  /*
   * |================================|
   * | Truck Collections by Container |
   * |================================|
   */
  truck_collections_by_container_page_header: 'LKW-Sammlungen nach Container Bericht',
  truck_collections_by_container_fetch_error:
    'Fehler beim Abrufen der LKW-Sammlungen nach Container',
  truck_collections_by_container_from_date: 'Von Datum',
  truck_collections_by_container_to_date: 'Bis Datum',
  truck_collections_by_container_truck_number: 'LKW-Name',
  truck_collections_by_container_container_number: 'Container-Nummer',
  truck_collections_by_container_container_address: 'Container-Adresse',
  truck_collections_by_container_location: 'Standort',
  truck_collections_by_container_status: 'Status',
  truck_collections_by_container_date: 'Datum',
  truck_collections_by_container_status_correct: 'Korrekter Standort',
  truck_collections_by_container_status_incorrect: 'Falscher Standort',
  truck_collections_by_container_open_in_maps: 'In Google Maps öffnen',
  truck_collections_by_container_export_csv: 'CSV exportieren',
  truck_collections_by_container_view_on_map: 'Auf Karte anzeigen',
  truck_collections_by_container_no_data_to_export: 'Keine Daten zum Exportieren',

  /*
   * |=======================|
   * | Container Collections |
   * |=======================|
   */
  container_collections_page_header: 'Container-Sammlungen Bericht',
  container_collections_fetch_error: 'Fehler beim Abrufen der Container-Sammeldaten',
  container_collections_from_date: 'Von Datum',
  container_collections_to_date: 'Bis Datum',
  container_collections_container_number: 'Container-Nummer',
  container_collections_container_address: 'Container-Adresse',
  container_collections_account_id: 'Konto-ID',
  container_collections_account_number: 'Kontonummer',
  container_collections_count: 'Anzahl der Sammlungen',
  container_collections_volume: 'Sammlungsvolumen',
  container_collections_export_csv: 'CSV exportieren',
  container_collections_no_data_to_export: 'Keine Daten zum Exportieren',

  // Common
  close_btn: 'Schließen',

  // TanstackTable UI
  table_search_placeholder: 'Suchen…',
  table_columns: 'Spalten',
  table_toggle_all: 'Alle umschalten',
  table_filter: 'Filter',
  table_clear_filter: 'Filter löschen',
  table_pin_left: 'Links anheften',
  table_pin_right: 'Rechts anheften',
  table_unpin: 'Anheftung aufheben',
  table_group_by_column: 'Nach dieser Spalte gruppieren',
  table_ungroup: 'Gruppierung aufheben',
  table_filter_all: 'Alle',
  table_no_values: 'Keine Werte',
  table_min: 'Min',
  table_max: 'Max',
  table_equals: 'Gleich',
  table_from: 'Von',
  table_to: 'Bis',
  table_yes: 'Ja',
  table_no: 'Nein',
  table_filter_placeholder: 'Filtern…',
  table_density_compact: 'Kompakt',
  table_density_standard: 'Standard',
  table_density_comfortable: 'Komfortabel',
  table_auto_page_size: 'Auto ({rows})',
};

export default de;
